          <dl class="stats reveal"{{{ root }}}>
{{#each items}}
            <div{{{ edit }}}><dt{{{ label.attrs }}}>{{{ label.html }}}</dt><dd{{{ value.attrs }}}>{{{ value.html }}}</dd></div>
{{/each}}
          </dl>
